import { createStore } from 'vuex';

const store = createStore({
  state: {
    auth: {
      isAuthenticated: false,
      unauthorizedMessage: '',
    },
    userEmail: '',
    userID: '',
    token: '',
    role: '',
    sessionExpiredMessage: '',
    logoutFlag: false,
    permission: {},
  },
  mutations: {
    setAuthenticated(state, isAuthenticated) {
      state.auth.isAuthenticated = isAuthenticated;
    },
    setUnauthorizedMessage(state, message) {
      state.auth.unauthorizedMessage = message;
    },
    setUserEmail(state, email) {
      state.userEmail = email;
    },
    setUserID(state, uid) {
      state.userID = uid;
    },
    setToken(state, token) {
      state.token = token;
    },
    setRole(state, role) {
        state.role = role;
    },
    setSessionExpiredMessage(state, message) {
        state.sessionExpiredMessage = message;
    },
    setLogoutFlag(state, logoutFlag) {
        state.logoutFlag = logoutFlag;
    },
    setPermission(state, permission) {
        state.permission = permission;
    },
  },
  actions: {
    login({ commit }) {
        commit('setAuthenticated', true);
        commit('setLogoutFlag', false);
    },
    logout({ commit }) {
        var logoutEventKey = `logoutEvent_${Date.now()}`;
        localStorage.setItem('logoutEventKey', logoutEventKey);
        localStorage.removeItem('token');
        localStorage.removeItem('userID');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('currentRoute');
        localStorage.removeItem('role');
        localStorage.removeItem('permission');
        commit('setAuthenticated', false);
        commit('setLogoutFlag', true);
        commit('setUnauthorizedMessage', '');
        commit('setUserEmail', '');
        commit('setUserID', '');
        commit('setToken', '');
        commit('setRole', '');
        commit('setPermission', '');
    },
    setSessionExpiredMessage({ commit }, message) {
        commit('setSessionExpiredMessage', message);
    }
  },
  modules: {},
  getters: {
    getSessionExpiredMessage: state => state.sessionExpiredMessage
  }
});

export default store;